// angular imports
import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';

// cc-common imports
import { DxWidgetUtils, IconConstants } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// service imports
import { ServerErrorService } from '../../../../_services/shared-services/server-error.service';
import { APPaymentService } from '../../_services/accounts-payable/ap-payment.service';

// model imports
import { APPaymentUpdatePostDateParametersDto } from '../../_models/accounts-payable/ap-payment/ap-payment-update-post-date-parameters-dto';

// constant imports
import { MessageInterval } from '../../../../_constants/messages-intervals';

@Component({
    selector: 'app-ap-payment-post-date-editor',
    templateUrl: './ap-payment-post-date-editor.component.html',
    styleUrls: ['./ap-payment-post-date-editor.component.scss']
})
export class APPaymentPostDateEditorComponent implements OnInit {
    @ViewChild('updatePaymentPopup', { static: false }) updatePaymentPopup: DxPopupComponent;

    @Input() title: string;
    @Input() communityId: number;
    @Input() managementCompanyId: number;
    @Input() paymentId: number;

    @Output() onClose = new EventEmitter<boolean>();

    visible = false;

    iconCancel = IconConstants.CANCEL;
    iconYes = IconConstants.CHECK;

    postDate: Date = new Date();
    isPostDateChanged = false;

    loadingVisible = false;

    constructor(
        private readonly apPaymentService: APPaymentService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onShown(): void {
        DxWidgetUtils.instantRepaint(this.updatePaymentPopup);
    }

    onHidden(): void {
        this.closeUpdatePayment();
    }

    onCancelClick(): void {
        this.closeUpdatePayment();
    }

    onYesClick(): void {
        this.updatePostDate();
    }

    private updatePostDate(): void {
        const baseParam: APPaymentUpdatePostDateParametersDto = new APPaymentUpdatePostDateParametersDto();
        baseParam.communityId = this.communityId;
        baseParam.managementCompanyId = this.managementCompanyId;
        baseParam.paymentId = this.paymentId;
        baseParam.postDate = this.postDate;

        this.loadingVisible = true;
        this.apPaymentService.updatePaymentPostDate(baseParam).subscribe(
            () => {
                notify('Payment updated successfully.', 'Success', MessageInterval.successMsgInterval);
                this.isPostDateChanged = true;
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }

    private closeUpdatePayment(): void {
        this.visible = false;

        this.onClose.emit(this.isPostDateChanged);
    }
}
